/**
 * «ماهِ فعال» مشترکِ همهٔ صفحه‌ها (v2.132.0).
 *
 * کاربر (۱۴۰۵/۰۷/۰۵): «وقتی چیزی را انتخاب می‌کنیم خودش بماند روی ماه… الان در پرداخت حقوق هی می‌آید روی مهر در حالی که
 * باید بیاید روی شهریور». هر صفحه ماهِ خودش را جدا نگه می‌داشت (یا اصلاً نگه نمی‌داشت و دورهٔ اولِ لیست را می‌گرفت).
 * حالا انتخابِ ماه در هر صفحه اینجا ذخیره می‌شود و صفحه‌های دیگر با همان باز می‌شوند.
 * ذخیره در localStorage (per مرورگر/کاربر) — دسترسی در try/catch تا حالتِ خصوصی خراب نشود.
 */
const KEY = "gx-active-ym";

export function getActiveYm() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    return v && v.year && v.month ? { year: Number(v.year), month: Number(v.month) } : null;
  } catch { return null; }
}

export function setActiveYm(year, month) {
  if (!year || !month) return;
  try { localStorage.setItem(KEY, JSON.stringify({ year: Number(year), month: Number(month) })); } catch { /* */ }
}

/** دورهٔ مطابقِ ماهِ فعال از فهرستِ دوره‌ها؛ وگرنه `fallback` (پیش‌فرض: اولیِ فهرست). */
export function pickActivePeriod(periods, fallback) {
  const a = getActiveYm();
  const list = periods || [];
  const hit = a && list.find((p) => Number(p.year) === a.year && Number(p.month) === a.month);
  return hit || fallback || list[0] || null;
}

/** ماهِ دوره را ماهِ فعال کن (برای وقتی کاربر دوره را عوض می‌کند). */
export function rememberPeriod(periods, periodId) {
  const p = (periods || []).find((x) => x.id === periodId);
  if (p) setActiveYm(p.year, p.month);
}
